<template>
  <div class="template-container">
    <div v-for="survey in surveys" :key="survey.sID" class="grid card-container">
      <div class="w-100">
        <div class="card-head-container align-items-start">
          <!-- Survey Name with Needs Approval Button -->
          <div class="d-flex justify-content-between w-100">
            <h4 class="survey-title" :title="survey.name">{{ survey.name }}</h4>
            <!-- Needs Approval Button with Icon Next to Survey Name -->
            <b-button 
              v-if="isSurveyAdmin && survey.status === 3" 
              class="needs-approval-button needs-approval-icon" 
              @click="openApproval(survey)"
              title="Click here to approve"
              variant="light"
              size="sm"
            >
              <b-icon icon="exclamation-triangle-fill" style="color: #fc7727;" />
            </b-button>
          </div>
        </div>
        
        <div class="w-100">
          <div class="d-flex justify-content-between align-items-end">
            <p :title="survey.description" class="grid description-container">{{ survey.description }}</p>
          </div>
          <div class="d-flex align-items-end justify-content-between">
            <div :id="'tag-container-' + survey.sID" :title="survey.tags"
              class="d-flex flex-wrap justify-content-start grid tag-button-container">
              <label v-for="(tag, index) in survey.tags" :key="tag" class="tag-button-child">
                {{ tag }}<span v-if="index !== survey.tags.length - 1">,</span>
              </label>
            </div>
          </div>
        </div>
      </div>

      <div class="w-100 d-flex justify-content-end align-items-center">
        <div class="d-flex justify-content-end">
          <b-button class="template-nav-button btn-default" @click="openPreview(survey)">View</b-button>
          <b-button v-if="isEdit" class="template-nav-button btn-alt" @click="openDelete(survey)">Delete</b-button>
          <b-button v-if="isSelect" class="template-nav-button btn-default" @click="selectItem(survey)">Select</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridViewSurvey",
  props: {
    surveys: {
      type: Array,
      default: [],
    },
    mode: { // One of "edit" or "select"
      type: String,
      default: "",
    },
    isSurveyAdmin: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isEdit() {
      return this.mode === "edit";
    },
    isSelect() {
      return this.mode === "select";
    },
  },
  methods: {
    openApproval(survey) {
      this.$emit("open-approval", survey);
    },
    openPreview(survey) {
      this.$emit("open-preview", survey);
    },
    openDelete(survey) {
      this.$emit("open-delete", survey);
    },
    selectItem(survey) {
      this.$emit("select-item", survey);
    },
  },
};
</script>

<style scoped>
div.template-container {
  justify-content: start !important;
  gap: 1.5rem 3.5% !important;
}

.grid.card-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  max-width: none;
  height: 280px;
  margin: 0px;
  padding: 1rem 1.5rem;
  background-color: white;
  border-radius: 30px;
}

.grid.description-container {
  display: -webkit-box;
  overflow: hidden;
  max-height: 4.2rem;
  color: lightgray !important;
  font-style: italic !important;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.needs-approval-button {
  background-color: transparent;
  color: #fc7727;
  border: none;
  box-shadow: none;
  font-size: 2rem;
  padding: 0px;
  cursor: pointer;
}

.needs-approval-button:hover {
  color: #ff8e4d !important;
}

.grid.tag-button-container {
  overflow-y: clip;
  width: 100%;
  max-height: 120px;
}

.tag-button-child {
  margin: 0px 2px;
}

.template-nav-button {
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.2);
}

.template-nav-button:first-child {
  margin-right: 8px;
}

.btn-default {
  background-color: #fc7727 !important;
  border: none;
}

.btn-default:hover {
  background-color: #ff8e4d !important;
}

.btn-alt {
  background: #DB3360 !important;
  border: none;
}

button.btn-alt:hover {
  background: #DB3360 !important;
}

@media screen and (max-width:1370px) {
  div.template-container {
    min-width: 450px !important;
    column-gap: 6% !important;
  }

  .grid.card-container {
    width: 47% !important;
  }
}

@media screen and (min-width:1370px) {
  div.template-container {
    column-gap: 3.5% !important;
  }

  .grid.card-container {
    width: 31% !important;
  }
}

@media screen and (min-width:1900px) {
  div.template-container {
    column-gap: 2% !important;
  }

  .grid.card-container {
    width: 23.5% !important;
  }
}

@media screen and (min-width:2300px) {
  div.template-container {
    column-gap: 1.25% !important;
  }

  .grid.card-container {
    width: 19% !important;
  }
}

@media screen and (max-width: 768px) {
  div.template-container {
    min-width: 0 !important;
    column-gap: 0 !important;
  }

  .grid.card-container {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/survey-dashboard/survey-views/GridViewSurvey.vue